import { qs, qsa } from './modules/util';

const MODAL_INITIATOR_SELECTOR = '.goto.js-modal';
const MODAL_CONTAINER_SELECTOR = '.modal-container';
const MODAL_ITEM_SELECTOR = '.modal-item';

const allModalOpener = qsa(MODAL_INITIATOR_SELECTOR);
const modal_container = qs(MODAL_CONTAINER_SELECTOR);

allModalOpener.forEach(item => {
  let id = item.getAttribute('data-id');
  let modal = qs(
    `${MODAL_CONTAINER_SELECTOR} ${MODAL_ITEM_SELECTOR}[data-id=${id}]`
  );
  let close = qs('.close', modal);
  let back = qs('.back', modal);
  let next = qs('.next-button', modal);

  let openModal = () => {
    modal_container.classList.add('show');
    modal.classList.add('selected');
  };

  let closeModal = () => {
    modal_container.classList.remove('show');
    modal.classList.remove('selected');
  };

  next.addEventListener('click', () => {
    closeModal();
    let id = qs('.next-button', modal).getAttribute('next-item-id');
    qs(`${MODAL_INITIATOR_SELECTOR}[data-id=${id}]`).click();
  });

  item.addEventListener('click', openModal);
  close.addEventListener('click', closeModal);
  back.addEventListener('click', closeModal);
});
